(function () {
  const parser = new DOMParser();

  // Convierte URL relativa a absoluta
  const abs = (url) => new URL(url, window.location.origin).href;

  function extractNextURL(doc, root) {
    let a = doc.querySelector(`#${root.id} a[rel="next"]`);
    if (a?.getAttribute('href')) return abs(a.getAttribute('href'));

    a = doc.querySelector('page-pagination a[rel="next"], a.pagination__nav-item[rel="next"]');
    if (a?.getAttribute('href')) return abs(a.getAttribute('href'));

    const link = doc.querySelector('link[rel="next"]');
    if (link?.getAttribute('href')) return abs(link.getAttribute('href'));

    return '';
  }

  function inferNextURL(current) {
    try {
      const u = new URL(current, window.location.origin);
      const curr = parseInt(u.searchParams.get('page') || '1', 10);
      u.searchParams.set('page', String(curr + 1));
      return u.href;
    } catch {
      return '';
    }
  }

  async function handleLoadMoreClick(box, btn) {
    const root = box.closest('[id^="shopify-section-"]');
    if (!root) return;

    const gridSel = box.dataset.gridSelector || '.product-list__inner';
    const grid = root.querySelector(gridSel);
    if (!grid) return;

    let nextURL = box.dataset.nextUrl || '';
    if (!nextURL) return;

    const loadingText = box.dataset.i18nLoading || 'Loading…';
    const originalLabel = btn.textContent.trim();

    // Evitar que los nuevos queden invisibles por animaciones del tema
    root.querySelector('product-list')?.removeAttribute('stagger-apparition');

    btn.disabled = true;
    btn.textContent = loadingText;

    try {
      const res = await fetch(nextURL, {
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
        credentials: 'same-origin'
      });

      const html = await res.text();
      const doc = parser.parseFromString(html, 'text/html');

      const incomingRoot = doc.querySelector(`#${root.id}`) || doc;
      const incomingGrid =
        incomingRoot.querySelector(gridSel) || doc.querySelector(gridSel);

      if (!incomingGrid) {
        throw new Error('Grid not found on next page');
      }

      // Insertar productos nuevos
      grid.insertAdjacentHTML('beforeend', incomingGrid.innerHTML);

      // Limpiar clases/atributos de animación en los últimos items
      Array.from(grid.children).slice(-60).forEach((el) => {
        el.classList?.remove(
          'reveal',
          'reveal-item',
          'stagger-apparition__item',
          'is-invisible',
          'invisible'
        );
        el.removeAttribute?.('reveal');
        el.removeAttribute?.('data-reveal');
        el.removeAttribute?.('hidden');
        if (el.style) {
          el.style.opacity = '';
          el.style.transform = '';
          el.style.transition = '';
          el.style.visibility = '';
        }
      });

      // Calcular siguiente URL
      let newNext = extractNextURL(doc, root);

      if (!newNext) {
        const guessed = inferNextURL(nextURL);
        if (guessed) {
          const testRes = await fetch(guessed, {
            headers: { 'X-Requested-With': 'XMLHttpRequest' },
            credentials: 'same-origin'
          });
          const testHtml = await testRes.text();
          const testDoc = parser.parseFromString(testHtml, 'text/html');
          const testIncomingRoot =
            testDoc.querySelector(`#${root.id}`) || testDoc;
          const testGrid =
            testIncomingRoot.querySelector(gridSel) ||
            testDoc.querySelector(gridSel);
          if (testGrid && testGrid.children.length > 0) newNext = guessed;
        }
      }

      nextURL = newNext || '';
      if (nextURL) {
        // Actualizamos el data-next-url para el próximo click
        box.dataset.nextUrl = nextURL;
        btn.disabled = false;
        btn.textContent = originalLabel;
      } else {
        // No hay más páginas → removemos el loadmore
        box.remove();
      }
    } catch (e) {
      console.error(e);
      btn.disabled = false;
      btn.textContent = originalLabel;
    }
  }

  // 🔹 Delegación global: funciona aunque Focal reemplace la sección por AJAX (desktop con filtros)
  function onDocumentClick(event) {
    const btn = event.target.closest('.ls-loadmore button');
    if (!btn) return;

    const box = btn.closest('.ls-loadmore[data-next-url]');
    if (!box) return;

    event.preventDefault();
    handleLoadMoreClick(box, btn);
  }

  document.addEventListener('click', onDocumentClick);
})();
